import { Component, OnInit, HostListener } from "@angular/core";
import { Router, ActivatedRoute } from "@angular/router";
import { environment } from "../../../environments/environment";
import { CommonHttpService } from "../commonHttp.service";
import { LoaderService } from "../../_shared/services/loader.service";
import { AddToCartService } from "../../_shared/services/add-to-cart.service";

@Component({
  selector: "app-Banner-product-all",
  templateUrl: "./Banner-product-all.component.html",
  styleUrls: ["./Banner-product-all.component.css"],
})
export class BannerProductAllComponent implements OnInit {
  bannerId: number;
  paramsId: number;
  relevance: any = 0;
  bannerDetail: any;
  baseUrl: any = environment.apiUrl;
  imageUrl: any = environment.imageUrl;
  products: any = [];
  banners: any = [];
  BannerDetails: any = {};
  brands: any = [];

  isListEnd: boolean = false;
  offset: number = 0;
  offsetLoader: boolean = false;
  offsetResFetched: boolean = true;
  brandIds: any = [];
  sortType: any = "PriceHigh";
  cart: any = {};
  cartItems: any = [];
  availableQuantity: number;
  quantityError: boolean = false;
  showLoaderProduct: boolean = false;
  productAll: any = [];
  constructor(
    private service: CommonHttpService,
    private addToCartService: AddToCartService,
    private router: Router,
    private route: ActivatedRoute,
    private loaderService: LoaderService
  ) {
    this.addToCartService.isCartChanged.subscribe((flag) => {
      this.cart = JSON.parse(localStorage.getItem("cart"));
      this.cartItems = this.cart != null ? this.cart.EcartItem : [];
      this.updateCart();
    });
  }

  ngOnInit() {
    window.scrollTo(0, 0);
    this.cart = JSON.parse(localStorage.getItem("cart"));

    this.cartItems = this.cart != null ? this.cart.EcartItem : [];
    this.route.params.subscribe((params) => {
      this.paramsId = params["id"];
      // let numValue = this.paramsId;
      // console.log(typeof numValue);
    });
    this.cartItems = this.cart != null ? this.cart.EcartItem : [];
    this.bannerDetail = JSON.parse(localStorage.getItem("selectedItem"));
    console.log(this.bannerDetail);
    this.route.params.subscribe((params) => {
      console.log(params);
      this.bannerId = parseInt(params["id"]);
    });

    this.getAllProducts();
    //  this.getfilterProducts();
  }

  getAllProducts() {
    this.showLoaderProduct = true;
    let postData = {
      BannerDetails: {
        // CategoryId: this.bannerDetail.categoryId,
        // BrandId: this.bannerDetail.brandId,
        // ProductId: this.bannerDetail.productId,
        BannerId: this.bannerId,
        // "OfferId": "",
      //  PromotionId: this.bannerDetail.promotionId,
      },
    };

    this.service
      .create(this.baseUrl + "BannerNewAPI/GetProductByBannerId", postData)
      .subscribe((data) => {
        console.log("all products");
        console.log(data);
        this.productAll = data;
        for (var i = 0; i < this.productAll.length; i++) {
          if (this.productAll[i].isAvailableOnline == true) {
            this.products.push(this.productAll[i]);
          }
        }
        console.log(this.products);
        //  this.products = data;
        this.showLoaderProduct = false;
      });
  }
  getfilterProducts() {
    this.showLoaderProduct = true;
    let postData = {
      BannerDetails: {
        // CategoryId: this.bannerDetail.categoryId,
        // BrandId: this.bannerDetail.brandId,
        // ProductId: this.bannerDetail.productId,
        BannerId: this.bannerId,
        // "OfferId": "",
     //   PromotionId: this.bannerDetail.promotionId,
        SortBy: this.relevance,
      },
    };

    this.service
      .create(this.baseUrl + "BannerNewAPI/GetProductByBannerId", postData)
      .subscribe((data) => {
        console.log("all products");
        console.log(data);
        this.products = data;

        console.log(this.products);
        //  this.products = data;
        this.updateCart();
        this.showLoaderProduct = false;
      });
  }

  add_remove_filter = function (checkstatus, itemId) {
    if (checkstatus.target.checked) {
      this.brandIds.push(itemId);
      this.offset = 0;
      this.isListEnd = false;
      this.products = [];
      this.loadData(1);
    } else {
      var pos = this.brandIds.indexOf(itemId);
      this.brandIds.splice(pos, 1);
      this.offset = 0;
      this.isListEnd = false;
      this.products = [];
      this.loadData(1);
    }
  };

  // sort_order = function (sortType) {
  //   this.sortType = sortType;
  //   this.products = [];
  //   this.offset = 0;
  //   this.isListEnd = false;
  //   this.loadData(1);
  // };
  sort_order = function () {
    console.log(this.relevance);
    this.getfilterProducts();
  };

  addToCart(product) {
    product.cartQuantity = 1;
    this.addToCartService.addToCart(product);
    console.log(this.products);
    console.log(this.products);
  }

  updateCart() {
    for (var i = 0; i < this.products.length; i++) {
      this.products[i].isAddedToCart = false;
    }
    for (var i = 0; i < this.cartItems.length; i++) {
      for (var j = 0; j < this.products.length; j++) {
        if (this.cartItems[i].ProductId == this.products[j].productId) {
          this.products[j].isAddedToCart = true;
          this.products[j].cartQuantity = this.cartItems[i].Quantity;
        }
      }
    }
  }

  substractquantity(cartQuantity, i) {
    this.quantityError = false;
    this.products[i].cartQuantity = cartQuantity - 1;
    this.addToCartService.addToCart(this.products[i]);
  }

  addQuantity(cartQuantity, i) {
    if (cartQuantity + 1 > this.products[i].totalStock) {
      this.quantityError = true;
      this.availableQuantity = this.products[i].totalStock;
      this.products[i].cartQuantity = cartQuantity;
    } else {
      this.quantityError = false;
      this.products[i].cartQuantity = cartQuantity + 1;
    }
    this.addToCartService.addToCart(this.products[i]);
  }

  onQuantityChange(cartQuantity, i) {
    if (cartQuantity > this.products[i].totalStock) {
      this.quantityError = true;
      this.availableQuantity = this.products[i].totalStock;
      this.products[i].cartQuantity = this.products[i].totalStock;
    } else {
      this.quantityError = false;
      this.products[i].cartQuantity = cartQuantity;
    }
    this.addToCartService.addToCart(this.products[i]);
  }

  @HostListener("window:scroll", [])
  onScroll(): void {
    if (
      window.innerHeight + window.scrollY >= document.body.offsetHeight - 500 &&
      this.products.length > 0
    ) {
      if (!this.isListEnd && this.offsetResFetched) {
        console.log("a");
        this.offsetResFetched = false;
        // this.loadData(2);
      }
    }
  }
}



// WEBPACK FOOTER //
// C:/Ajatus WorkSpace/Now Grocery/now-grocery/NowGroceryStoreFront/src/app/components/Banner-product-all/Banner-product-all.component.ts